<template>
   <transition name="fade">
      <div id="popup_login" v-on:click="$store.commit('loginModal', false)">
         <div class="popup_block" @click.stop>
            <div class="close" v-on:click="$store.commit('loginModal', false)"></div>
            <div class="pos_relative">
               <div class="login_form" :key="1" v-if="show">
                  <div class="title deactive">{{ $store.getters.t('sign_in') }}</div>
                  <div class="social">
                     <ul>
                        <li>
                           <img @click="authenticate('facebook')" src="/vue/images/facebook.png">
                        </li>
                        <li>
                           <img  @click="authenticate('vk')" src="/vue/images/vk.png">
                        </li>
                        <li>
                           <img @click="authenticate('google')" src="/vue/images/google.png">
                        </li>
                        <li>
                           <img @click="authenticate('linkedin')" src="/vue/images/linkedin.png">
                        </li>
                     </ul>
                  </div>
                  <form v-on:submit.prevent="login">
                     <div class="input_type">
                        <span v-on:click="activeInput($event)">{{ $store.getters.t('email') }}</span>
                        <input
                            placeholder="example@email.com"
                            name="email"
                            required
                            type="text"
                            v-validate="'required|email'"
                            v-on:input="activeInput($event)"
                            v-on:keyup.tab="activeInput($event)"
                            v-on:click="activeInput($event)"
                        >
                        <div
                            class="error_text"
                            v-show="errors.first('email')"
                        >{{ $store.getters.t('invalid_email') }}
                        </div>
                        <div class="correct_text" v-show="!errors.first('email') || !ajax_errors.email"></div>
                        <div class="error_icon" v-show="errors.first('email')"></div>
                     </div>

                     <div class="input_type">
                        <span v-on:click="activeInput($event)">{{ $store.getters.t('password') }}</span>
                        <input
                            placeholder="****************"
                            required
                            name="password"
                            type="password"
                            v-validate="'required|min:6'"
                            v-on:input="activeInput($event)"
                            v-on:keyup.tab="activeInput($event)"
                            v-on:click="activeInput($event)"
                        >
                        <div
                            class="error_text"
                            v-show="errors.first('password')"
                        >{{ $store.getters.t('invalid_password') }}
                        </div>
                        <div class="correct_text" v-show="!errors.first('password')"></div>
                        <div class="error_icon" v-show="errors.first('password')"></div>
                     </div>
                     <div class="check_me">
                        <input id="remember" type="checkbox" name="remember_me" checked>
                        <label for="remember">{{ $store.getters.t('remamber_me') }}</label>
                     </div>
                     <div class="forget_password">
                        <a
                            href="#"
                            @click.prevent="$store.commit('forgetPassword', true )"
                        >{{ $store.getters.t('forgot_password') }}</a>
                     </div>
                     <input class="submit_button" type="submit" :value="$store.getters.t('sign_in')">
                  </form>
                  <div
                      class="title reg_button"
                      @click="show = !show"
                  >{{ $store.getters.t('registration') }}
                  </div>
               </div>
               <div class="reg_form" :key="2" v-if="!show">
                  <div class="title deactive">{{ $store.getters.t('registration') }}</div>
                  <div class="social">
                     <ul>
                        <li>
                           <img @click="authenticate('facebook')" src="/vue/images/facebook.png">
                        </li>
                        <!--<li>-->
                           <!--<img @click="authenticate('linkedin')" src="/vue/images/linkedin.png">-->
                        <!--</li>-->
                        <li>
                           <img  @click="authenticate('vk')" src="/vue/images/vk.png">
                        </li>
                        <li>
                           <img @click="authenticate('google')" src="/vue/images/google-plus.png">
                        </li>
                     </ul>
                  </div>
                  <form v-on:submit.prevent="signUp">
                     <div class="input_type">
                        <span v-on:click="activeInput($event)">{{ $store.getters.t('email') }}</span>
                        <input
                            placeholder="example@email.com"
                            required
                            name="email"
                            type="text"
                            v-validate="'required|email'"
                            v-on:input="activeInput($event)"
                            v-on:keyup.tab="activeInput($event)"
                            v-on:click="activeInput($event)"
                        >
                        <div
                            class="error_text"
                            v-show="errors.first('email') || ajax_errors.email"
                        >
                           <template v-if="ajax_errors.email">
                              {{ ajax_errors.email[0] }}
                           </template>
                           <template v-else>
                              {{ $store.getters.t('invalid_email') }}
                           </template>
                        </div>
                        <div class="correct_text" v-show="!errors.first('email') || !ajax_errors.email"></div>
                        <div class="error_icon" v-show="errors.first('email') || ajax_errors.email"></div>
                     </div>
                     <div class="input_type">
                        <span v-on:click="activeInput($event)">{{ $store.getters.t('password') }}</span>
                        <input
                            type="password"
                            v-validate="'required|min:6'"
                            name="password"
                            ref="password"
                            v-on:input="activeInput($event)"
                            v-on:keyup.tab="activeInput($event)"
                            v-on:click="activeInput($event)"
                            required
                        >
                        <div
                            class="error_text"
                            v-show="errors.first('password') || ajax_errors.password"
                        >{{ $store.getters.t('invalid_password') }}
                        </div>
                        <div class="correct_text" v-show="!errors.first('password') || !ajax_errors.password"></div>
                        <div class="error_icon" v-show="errors.first('password') || ajax_errors.password"></div>
                     </div>
                     <div class="input_type">
                <span
                    v-on:click="activeInput($event)"
                >{{ $store.getters.t('password_confirmation') }}</span>
                        <input
                            required
                            name="password_confirmation"
                            type="password"
                            v-validate="'required|min:6|confirmed:password'"
                            v-on:input="activeInput($event)"
                            v-on:keyup.tab="activeInput($event)"
                            v-on:click="activeInput($event)"
                        >
                        <div
                            class="error_text"
                            v-show="errors.first('password_confirmation')"
                        >{{ $store.getters.t('invalid_password_confirmation') }}
                        </div>
                        <div class="correct_text" v-show="!errors.first('password_confirmation')"></div>
                        <div class="error_icon" v-show="errors.first('password_confirmation')"></div>
                     </div>
                     <div class="policy_div">
                        <div class="check_me">
                           <input id="remember_2"
                                  type="checkbox"
                                  name="policy"
                                  v-validate="'required'"
                                  v-model="checked">
                           <label for="remember_2" :class="!checked ? 'no_valid' : ''"></label>
                           <a :href="'/' + $store.getters.locale + '/policy'" target='_blank'
                              class="policy_link">{{ $store.getters.t('policy') }}</a>
                        </div>
                     </div>

                     <input class="submit_button" type="submit" :value="$store.getters.t('registration')">
                  </form>
                  <div class="title login_button" @click="show = !show">{{ $store.getters.t('sign_in') }}</div>
               </div>
            </div>
         </div>
      </div>
   </transition>
</template>
<script>
  import fbLogin from "../social/facebook.vue";
  import googleLogin from "../social/google.vue";
  import linkedinLogin from "../social/linkedin.vue";
  import vkLogin from "../social/vk.vue";
  import beautifulForm from "../../mixins/beautifulForm.js";

  export default {
    mixins: [beautifulForm],
    components: {
      "fb-login": fbLogin,
      "google-login": googleLogin,
      "linkedin-login": linkedinLogin,
      "vk-login": vkLogin
    },
    data() {
      return {
        show: true,
        checked: true,
        ajax_errors: {
          email: false,
          password: false,
          policy: false,
        }
      };
    },
    mounted() {
      if (this.$store.getters.fromSaveButton) {
        this.show = false;
        this.$store.commit('fromSaveButton', false);
      }
    },
    methods: {
      login(form) {
        this.$validator.validate().then(res => {
          if (res) {
            let formData = new FormData(form.target);
            NProgress.start();
            this.$http({
              method: "post",
              url: `/api/login`,
              data: formData
            }).then(response => {
              if (response.data.user) {
                this.email = null;
                this.password = null;
                this.$store.commit("user", response.data.user);
                this.$store.commit("loginModal", false);
              }
              NProgress.done();
            });
          }
        });
      },
      signUp(form) {
        this.$validator.validate().then(res => {
          if (res) {
            let formData = new FormData(form.target);
            NProgress.start();
            this.$http({
              method: "post",
              url: `/api/signUp`,
              data: formData
            }).then(res => {
              if (res.data.errors) {
                this.ajax_errors = res.data.errors;
              } else if (res.data.success) {
                this.login(form);
                this.show = !this.show;
                this.$store.commit("newMessage", {
                  show: true,
                 type: "success",
                  messageTitle: this.$store.getters.t("success"),
                  message: this.$store.getters.t("registration_success")
                });
              }
              NProgress.done();
            });
          }
        });
      },
      authenticate: function (provider) {
        this.$auth.authenticate(provider).then((response) => {
          console.log(response.data.user);
          this.email = null;
          this.password = null;
          this.$store.commit("user", response.data.user);
          this.$store.commit("loginModal", false);
        });

      },
    }
  };
</script>
<style>
   .fade-enter-active,
   .fade-leave-active {
      transition: opacity 0.8s;
   }

   .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
   {
      opacity: 0;
   }
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/login-registarion.vue